(function() {

    gsap.registerPlugin(ScrollTrigger);

    const HomeView = Barba.BaseView.extend({
        namespace: 'home',
        video: null,
        homeHeaderEl: null,
    
        expertisesEl: null,
        expertisesEinnerEl: null,
        expertiseWrapperEl: null,
        timeline: null,
    
        bounds1: null,
        bounds2: null,
        offset: null,
    
        onEnter() {
            this.homeHeaderEl = this.container.querySelector('.jsHomeHeader');
    
            initProjectBoxes(this.container);
            initScrollForMoreTriggers(this.container);
            setIframeAspectRatios(this.container);
            
            new MainMenu(this.container);
            new InViewAnimation();
            new SearchModal(this.container);
    
            setTimeout(_ => { setScrollAnchorPosition(this.container); }, 500)
            window.addEventListener('hashchange', _ => {
                setTimeout(_ => {
                    setScrollAnchorPosition(this.container);
                }, 500);
            });
    
            setTimeout(_ => {
                this.initHeaderSlogan();
            }, 1000);
            
            this.animateIn();
            this.initHomeSlideshow();
            this.initHomeScrollTrigger();
        },
    
        initHomeScrollTrigger () {
            this.expertisesEl = this.container.querySelector('.jsHomeExpertises');
            this.expertisesInnerEl = this.expertisesEl.querySelector('.jsHomeExpertisesInner');
            this.expertiseWrapperEl = this.expertisesEl.querySelector('.jsHomeExpertisesInnerWrapper');
    
            this.bounds1 = this.expertisesInnerEl.getBoundingClientRect();
            this.bounds2 = this.expertiseWrapperEl.getBoundingClientRect();
            this.offset = -(this.bounds2.width - this.bounds1.width);
    
            ScrollTrigger.addEventListener('refreshInit', _ => {
                this.bounds1 = this.expertisesInnerEl.getBoundingClientRect();
                this.bounds2 = this.expertiseWrapperEl.getBoundingClientRect();
                this.offset = -(this.bounds2.width - this.bounds1.width);
            });
    
            this.timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: this.expertisesEl,
                    pin: true,
                    start: 'top top',
                    end: () => '+=' + this.bounds1.width * 2,
                    scrub: true,
                    pinSpacing: true,
                    invalidateOnRefresh: true
                }
            })
                .to(this.expertiseWrapperEl, { x: () => {
                    this.bounds1 = this.expertisesInnerEl.getBoundingClientRect();
                    this.bounds2 = this.expertiseWrapperEl.getBoundingClientRect();
                    this.offset = -(this.bounds2.width - this.bounds1.width);
    
                    return this.offset;
                }, ease: Power0.easeNone })
            ;
        },
    
        initHomeSlideshow() {
            new HomeHeaderSlideshow(this.homeHeaderEl);
        },
    
        initHeaderSlogan() {
            const slogan = this.container.querySelector('.jsHeaderSlogan');
            const circle = slogan.querySelector('.jsCircleMask');
    
            if (circle !== null) {
                let circlePos = circle.getBoundingClientRect();
                let first = true;
    
                window.addEventListener('resize', _ => {
                    TweenLite.set(circle, { x: 0, y: 0 });
                    circlePos = circle.getBoundingClientRect();
                });
    
                window.addEventListener('mousemove', e => {
                    const circleX = e.pageX - (circlePos.x || circlePos.left) - (circlePos.width / 2);
                    const circleY = e.pageY - (circlePos.y || circlePos.top) - (circlePos.height / 2);
    
                    if (first) TweenLite.set(circle, { x: circleX, y: circleY, opacity: 1 });
                    else TweenLite.to(circle, 1, { x: circleX, y: circleY });
    
                    first = false;
                });
            }
        },
    
        animateIn() {
            const slogan = this.container.querySelector('.jsHeaderSlogan');
            const scrollForMore = this.container.querySelector('.jsFirstScrollForMore');
    
            new TimelineMax()
                .set(slogan, { x: -10 })
                .set(scrollForMore, { y: 10 })
    
                .to(slogan, 1, { x: 0, opacity: 1, ease: Power2.easeOut })
                .to(scrollForMore, 1, { y: 0, opacity: 1, ease: Power2.easeOut }, '-=1')
    
                .add(_ => {
                    slogan.classList.remove('start-hidden');
                    scrollForMore.classList.remove('start-hidden');
                })
            ;
        }
    });
    
    HomeView.init();
    const TopicHomeView = Barba.BaseView.extend({
        namespace: 'topic-home',
    
        onEnter() {
            initProjectBoxes(this.container);
            initScrollForMoreTriggers(this.container);
            setIframeAspectRatios(this.container);
            
            new MainMenu(this.container);
            new InViewAnimation();
            new SearchModal(this.container);
    
            setTimeout(_ => { setScrollAnchorPosition(this.container); }, 500)
            window.addEventListener('hashchange', _ => {
                setTimeout(_ => {
                    setScrollAnchorPosition(this.container);
                }, 500);
            });
            
            this.animateIn();
        },
    
        animateIn() {
            
        }
    });
    
    TopicHomeView.init();
    const SingleProjectView = Barba.BaseView.extend({
        namespace: 'single-project',
        pannellumView: null,
        panoWrapper: null,
    
        onEnter() {
            new MainMenu(this.container);
            new InViewAnimation();
            new ReadMoreTrigger(this.container);
            new SearchModal(this.container);
    
            initSlideshows(this.container);
            setIframeAspectRatios(this.container);
    
            this.initArModal();
            this.init360Pano();
            this.initNewsGridSliders();
    
            const prevState = Barba.HistoryManager.prevStatus();
            if (prevState && typeof prevState.namespace !== 'undefined' && prevState.namespace === 'archive') {
                const backLink = this.container.querySelector('.jsProjectBackLink');
                backLink.addEventListener('click', e => {
                    e.preventDefault();
                    window.history.back();
                });
            }
        },
    
        initNewsGridSliders() {
            this.container.querySelectorAll('.jsNewsGridSlider').forEach(el => new NewsGridSlider(el));
        },
    
        initArModal() {
            const arModalTrigger = this.container.querySelector('.jsProjectArBtn');
    
            if (arModalTrigger !== null) {
                const arWrapper = arModalTrigger.parentElement.querySelector('.jsProjectArWrapper');
    
                if (arWrapper) {
                    document.addEventListener('keyup', e => {
                        if (e.key.toLowerCase() === 'escape') {
                            arWrapper.classList.remove('visible');
                        }
                    });
    
                    arWrapper.addEventListener('click', e => {
                        if (e.target.classList.contains('jsClose')) {
                            e.preventDefault();
                            arWrapper.classList.remove('visible');
                        }
                    });
    
                    arModalTrigger.addEventListener('click', e => {
                        if (window.innerWidth >= 550) {
                            e.preventDefault();
                            arWrapper.classList.add('visible');
                        }
                    });
                }
            }
        },
    
        init360Pano() {
            const panoTrigger = this.container.querySelector('.jsProject360Btn');
    
            if (panoTrigger !== null) {
                panoTrigger.addEventListener('click', _ => {
                    // Create a panorama wrapper
                    const uniqid = Math.random() * 16;
                    this.panoWrapper = document.createElement('div');
        
                    this.panoWrapper.classList.add('pano-wrapper');
                    this.panoWrapper.id = 'pano-wrapper-' + uniqid;
    
                    const closeBtn = document.createElement('button');
                    closeBtn.type = 'button';
                    closeBtn.classList.add('pano-wrapper__close-btn');
                    this.panoWrapper.appendChild(closeBtn);
    
                    // Add a close event listener
                    closeBtn.addEventListener('click', _ => this.closePano());
    
                    // Add to the body
                    this.panoWrapper.style.opacity = 0;
                    document.body.appendChild(this.panoWrapper);
    
                    // Init the viewer
                    this.pannellumView = pannellum.viewer('pano-wrapper-' + uniqid, {
                        'type': 'equirectangular',
                        'panorama': panoTrigger.dataset.panoUrl,
                        'autoLoad': true
                    });
    
                    // Show the panorama
                    TweenLite.to(this.panoWrapper, 0.5, { opacity: 1, ease: Power2.easeInOut });
                });
            }
        },
    
        closePano() {
            TweenLite.to(this.panoWrapper, 0.5, { opacity: 0, ease: Power2.easeInOut, onComplete: _ => {
                this.pannellumView.destroy();
                this.panoWrapper.parentElement.removeChild(this.panoWrapper);
            } });
        }
    });
    
    SingleProjectView.init();
    
    const SingleNewsView = Barba.BaseView.extend({
        namespace: 'single-news',
    
        onEnter() {
            new MainMenu(this.container);
            new InViewAnimation();
            new SearchModal(this.container);
    
            setIframeAspectRatios(this.container);
            initSlideshows(this.container);
    
            this.init360Pano();
        },
    
        init360Pano() {
            const panoTrigger = this.container.querySelector('.jsProject360Btn');
    
            if (panoTrigger !== null) {
                panoTrigger.addEventListener('click', _ => {
                    // Create a panorama wrapper
                    const uniqid = Math.random() * 16;
                    this.panoWrapper = document.createElement('div');
    
                    this.panoWrapper.classList.add('pano-wrapper');
                    this.panoWrapper.id = 'pano-wrapper-' + uniqid;
    
                    const closeBtn = document.createElement('button');
                    closeBtn.type = 'button';
                    closeBtn.classList.add('pano-wrapper__close-btn');
                    this.panoWrapper.appendChild(closeBtn);
    
                    // Add a close event listener
                    closeBtn.addEventListener('click', _ => this.closePano());
    
                    // Add to the body
                    this.panoWrapper.style.opacity = 0;
                    document.body.appendChild(this.panoWrapper);
    
                    // Init the viewer
                    this.pannellumView = pannellum.viewer('pano-wrapper-' + uniqid, {
                        'type': 'equirectangular',
                        'panorama': panoTrigger.dataset.panoUrl,
                        'autoLoad': true
                    });
    
                    // Show the panorama
                    TweenLite.to(this.panoWrapper, 0.5, { opacity: 1, ease: Power2.easeInOut });
                });
            }
        },
    
        closePano() {
            TweenLite.to(this.panoWrapper, 0.5, {
                opacity: 0, ease: Power2.easeInOut, onComplete: _ => {
                    this.pannellumView.destroy();
                    this.panoWrapper.parentElement.removeChild(this.panoWrapper);
                }
            });
        }
    });
    
    SingleNewsView.init();
    const ProjectArchiveView = Barba.BaseView.extend({
        namespace: 'project-archive',
    
        onEnter() {
            initProjectBoxes(this.container);
            setIframeAspectRatios(this.container);
            
            new MainMenu(this.container);
            new InViewAnimation();
            new SearchModal(this.container);
        }
    });
    
    ProjectArchiveView.init();
    const NewsArchiveView = Barba.BaseView.extend({
        namespace: 'news-archive',
    
        onEnter: function() {
            new MainMenu(this.container);
            new InViewAnimation();
            new SearchModal(this.container);
            
            setIframeAspectRatios(this.container);
        }
    });
    
    NewsArchiveView.init();
    const AboutFaroView = Barba.BaseView.extend({
        namespace: 'about-faro',
    
        onEnter: function() {
            new MainMenu(this.container);
            new InViewAnimation();
            new SearchModal(this.container);
    
            this.initClientList();
            setIframeAspectRatios(this.container);
    
            setTimeout(_ => { setScrollAnchorPosition(this.container); }, 500)
            window.addEventListener('hashchange', _ => { setScrollAnchorPosition(this.container); });
        },
    
        initClientList() {
            const list = this.container.querySelector('.jsClientList');
            const title = list.querySelector('.jsClientListTitle');
            const expandWrapper = list.querySelector('.jsClientListExpandWrapper');
            const loadMoreBtn = list.querySelector('.jsClientListShowMore');
    
            title.addEventListener('click', _ => {
                if (!expandWrapper.classList.contains('open')) {
                    title.classList.add('active');
    
                    TweenLite.set(expandWrapper, { display: 'block', opacity: 0 });
                    const height = expandWrapper.offsetHeight;
                    TweenLite.set(expandWrapper, { height: 0, opacity: 1 });
                    TweenLite.to(expandWrapper, 0.5, { height: height, ease: Power2.easeInOut, onComplete: _ => {
                        expandWrapper.classList.add('open');
                        TweenLite.set(expandWrapper, { clearProps: 'all' });
                    } });
                }
                else {
                    title.classList.remove('active');
    
                    TweenLite.to(expandWrapper, 0.5, { height: 0, ease: Power2.easeInOut, onComplete: _ => {
                        expandWrapper.classList.remove('open');
                        expandWrapper.classList.remove('open-children');
                        loadMoreBtn.classList.remove('active');
    
                        TweenLite.set(expandWrapper, { clearProps: 'all' });
                    } });
                }            
            });
    
            loadMoreBtn.addEventListener('click', e => {
                e.preventDefault();
    
                if (!expandWrapper.classList.contains('open-children')) {    
                    const initialHeight = expandWrapper.offsetHeight;
                    expandWrapper.classList.add('open-children');
    
                    const height = expandWrapper.offsetHeight;
                    TweenLite.set(expandWrapper, { height: initialHeight });
                    
                    TweenLite.to(expandWrapper, 0.5, { height: height, ease: Power2.easeInOut, onComplete: _ => {
                        loadMoreBtn.classList.add('active');
                        TweenLite.set(expandWrapper, { clearProps: 'all' });
                    } });
                }
                else {
                    expandWrapper.classList.remove('open-children');
                    const height = expandWrapper.offsetHeight;
                    expandWrapper.classList.add('open-children');
    
                    TweenLite.to(expandWrapper, 0.5, { height: height, ease: Power2.easeInOut, onComplete: _ => {
                        expandWrapper.classList.remove('open-children');
                        loadMoreBtn.classList.remove('active');
                        TweenLite.set(expandWrapper, { clearProps: 'all' });
                    } });
                }
            });
        }
    });
    
    AboutFaroView.init();
    const ContactView = Barba.BaseView.extend({
        namespace: 'contact',
    
        onEnter: function() {
            new MainMenu(this.container);
            new InViewAnimation();
            new SeMailchimpForm(this.container);
            new SearchModal(this.container);
    
            setIframeAspectRatios(this.container);
    
            setScrollAnchorPosition(this.container);
            window.addEventListener('hashchange', _ => { setScrollAnchorPosition(this.container); });
        }
    });
    
    ContactView.init();
    const ArchiveView = Barba.BaseView.extend({
        namespace: 'archive',
        map: null,
        activeFilters: [],
        mapMarkers: [],
        infobox: null,
        prevVisibleMarkerList: [],
        mapIcon: { url: se_ajax.template_dir + '/dist/images/map-marker@2x.png', scaledSize: new google.maps.Size(12, 12), anchor: new google.maps.Point(6, 6) },
        mapIconActive: { url: se_ajax.template_dir + '/dist/images/map-marker-active@2x.png', scaledSize: new google.maps.Size(22, 22), anchor: new google.maps.Point(11, 11) },
    
        onEnter: function() {
            this.filterOptions = this.container.querySelectorAll('.jsArchiveFilterOption');
            this.searchForm = this.container.querySelector('.jsArchiveSearchForm');
            this.searchClearBtn = this.searchForm.querySelector('.clear');
            this.searchInput = this.searchForm.querySelector('.input');
            this.filterClearBtn = this.container.querySelector('.jsArchiveFilterClearAlll');
    
            new MainMenu(this.container);
            new InViewAnimation();
            new SearchModal(this.container);
    
            this.initViewSwitch();
            this.initFilters();
            this.setSearchClearBtnVisibility();
            this.setClearFilterBtnVisibility();
            setIframeAspectRatios(this.container);
    
            // Init the map
            if (seGoogleMapsReady) this.initMap();
            else window.addEventListener('se-google-maps-ready', this.initMap);
    
            // Init the archive filter
            new ArchiveFilter(this.container.querySelector('.jsArchiveFilters'));
    
            // Put the locations on the map
            this.updateMapLocations();
    
            // Init the search input clear button
            this.searchClearBtn.addEventListener('click', e => {
                this.searchInput.value = '';
                this.updateActiveFilters();
            });
    
            // Clear all filters
            this.filterClearBtn.addEventListener('click', _ => this.clearAllFilters());
        },
    
        clearAllFilters() {
            this.searchInput.value = '';
    
            for (let i = 0; i < this.filterOptions.length; i++) {
                this.filterOptions[i].checked = false;
            }
    
            this.updateActiveFilters();
        },
    
        setSearchClearBtnVisibility() {
            if (this.searchInput.value === '') this.searchClearBtn.style.opacity = 0;
            else this.searchClearBtn.style.opacity = 1;
        },
    
        setClearFilterBtnVisibility() {
            let isFiltered = false;
    
            if (this.searchInput.value !== '') {
                isFiltered = true;
            }
    
            for (let i = 0; i < this.filterOptions.length; i++) {
                if (this.filterOptions[i].checked) {
                    isFiltered = true;
                }
            }
    
            if (isFiltered) this.filterClearBtn.style.opacity = 1;
            else this.filterClearBtn.style.opacity = 0;
        },
    
        initViewSwitch() {
            const viewSwitch = this.container.querySelector('.jsArchiveViewSwitch');
    
            if (viewSwitch) {
                const viewWrapper = this.container.querySelector('.jsArchiveViewWrapper');
                const btns = viewSwitch.querySelectorAll('button');
                const views = viewWrapper.querySelectorAll('.jsArchiveViewWrapper > div');
    
                Array.prototype.forEach.call(btns, btn => {
                    btn.addEventListener('click', e => {
                        e.preventDefault();
    
                        const view = btn.dataset.switchView;
    
                        for (let i = 0; i < btns.length; i++) {
                            if (btns[i].dataset.switchView !== view) btns[i].classList.remove('active');
                            else btns[i].classList.add('active');
    
                            if (views[i].dataset.view !== view) views[i].classList.remove('active');
                            else views[i].classList.add('active');
                        }
                    });
                });
            }
        },
    
        initFilters() {
            for (let i = 0; i < this.filterOptions.length; i++) {
                this.filterOptions[i].addEventListener('change', this.updateActiveFilters.bind(this));
            }
    
            const currentUrl = new Url();
            if (currentUrl.query['category']) this.activeFilters['category'] = [currentUrl.query['category']];
    
            // Init the search form
            this.searchForm.addEventListener('submit', e => {
                e.preventDefault();
                this.updateActiveFilters();
            });
    
            let inputChangeTimeout = null;
    
            this.searchForm.addEventListener('input', e => {
                if (inputChangeTimeout) {
                    clearTimeout(inputChangeTimeout);
                    inputChangeTimeout = null;
                }
    
                inputChangeTimeout = setTimeout(_ => {
                    this.updateActiveFilters();
                }, 500);
            });
        },
    
        updateActiveFilters() {
            const viewWrapper = this.container.querySelector('.jsArchiveViewWrapper');
            const gridView = viewWrapper.querySelector('.grid');
    
            this.setSearchClearBtnVisibility();
            this.setClearFilterBtnVisibility();
    
            // Set the active filters
            this.activeFilters = {};
            for (let i = 0; i < this.filterOptions.length; i++) {
                if (this.filterOptions[i].checked) {
                    if (this.activeFilters[this.filterOptions[i].name] === undefined) this.activeFilters[this.filterOptions[i].name] = [];
                    this.activeFilters[this.filterOptions[i].name].push(this.filterOptions[i].value);
                }
            }
    
            // Set the search query
            const searchQuery = this.searchForm.querySelector('input').value;
            if (searchQuery) this.activeFilters['search-query'] = searchQuery;
    
            // Set the URL
            const url = new Url(archiveBaseUrl);
            const currentUrl = new Url();
    
            if (currentUrl.query['category']) {
                url.query['category'] = currentUrl.query['category'];
                this.activeFilters['category'] = [currentUrl.query['category']];
            }
    
            if (this.activeFilters['filter-2'] !== undefined) url.query['filter-2'] = this.activeFilters['filter-2'].join(',');
            else delete url.query['filter-2'];
    
            if (this.activeFilters['filter-3'] !== undefined) url.query['filter-3'] = this.activeFilters['filter-3'].join(',');
            else delete url.query['filter-3'];
    
            if (this.activeFilters['filter-4'] !== undefined) url.query['filter-4'] = this.activeFilters['filter-4'].join(',');
            else delete url.query['filter-4'];
    
            if (this.activeFilters['filter-5'] !== undefined) url.query['filter-5'] = this.activeFilters['filter-5'].join(',');
            else delete url.query['filter-5'];
    
            if (this.activeFilters['search-query'] !== undefined) url.query['search-query'] = this.activeFilters['search-query'];
            else delete url.query['search-query'];
    
            window.history.pushState(null, null, url.toString());
    
            // Update the GRID
            const xmlhttp = new XMLHttpRequest();
            const params = new FormData();
    
            params.append('action', 'get_project_archive_grid');
            params.append('base_url', archiveBaseUrlSearch + window.location.search);
            params.append('page_number', 1);
            params.append('posts_per_page', 9);
    
            if (this.activeFilters['category'] !== undefined) params.append('category', this.activeFilters['category'].join(','));
            if (this.activeFilters['filter-2'] !== undefined) params.append('filter-2', this.activeFilters['filter-2'].join(','));
            if (this.activeFilters['filter-3'] !== undefined) params.append('filter-3', this.activeFilters['filter-3'].join(','));
            if (this.activeFilters['filter-4'] !== undefined) params.append('filter-4', this.activeFilters['filter-4'].join(','));
            if (this.activeFilters['filter-5'] !== undefined) params.append('filter-5', this.activeFilters['filter-5'].join(','));
            if (this.activeFilters['search-query'] !== undefined) params.append('search-query', this.activeFilters['search-query']);
    
            // Animate the grid out
            TweenLite.to(viewWrapper.querySelector('.grid'), 0.5, { opacity: 0, ease: Power2.easeInOut });
    
            // Get the new grid
            xmlhttp.onreadystatechange = _ => {
                if (xmlhttp.readyState === XMLHttpRequest.DONE) {
                    if (xmlhttp.status === 200) {
                        const response = JSON.parse(xmlhttp.responseText);
    
                        gridView.innerHTML = response.grid_html;
                        TweenLite.to(viewWrapper.querySelector('.grid'), 0.5, { opacity: 1, ease: Power2.easeInOut });
                    }
                    else {
                        alert('Oops, something went wrong..');
                    }
                }
            };
    
            xmlhttp.open('POST', se_ajax.ajaxurl, true);
            xmlhttp.send(params);
    
            // Update the map
            this.updateMapLocations();
        },
    
        initMap() {
            this.map = new google.maps.Map(this.container.querySelector('.jsArchiveMap'), {
                center: { lat: 52.152854, lng: 5.086075 },
                zoom: 8,
                styles: [{"featureType":"landscape","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"stylers":[{"hue":"#00aaff"},{"saturation":-100},{"gamma":2.15},{"lightness":12}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"lightness":24}]},{"featureType":"road","elementType":"geometry","stylers":[{"lightness":57}]}],
                disableDefaultUI: true,
                zoomControl: true,
                scrollWheel: false
            });
    
            this.map.addListener('click', this.closeInfoBox.bind(this));
            
            let timeout = null;
            this.map.addListener('bounds_changed', _ => {
                if (timeout) clearTimeout(timeout);
    
                timeout = setTimeout(_ => {
                    this.updateSubProjectList();
                }, 1000);
            });
        },
    
        updateMapLocations() {
            // Get the locations
            const xmlhttp = new XMLHttpRequest();
            const params = new FormData();
    
            params.append('action', 'get_map_projects');
    
            if (this.activeFilters['category'] !== undefined) params.append('category', this.activeFilters['category'].join(','));
            if (this.activeFilters['filter-2'] !== undefined) params.append('filter-2', this.activeFilters['filter-2'].join(','));
            if (this.activeFilters['filter-3'] !== undefined) params.append('filter-3', this.activeFilters['filter-3'].join(','));
            if (this.activeFilters['filter-4'] !== undefined) params.append('filter-4', this.activeFilters['filter-4'].join(','));
            if (this.activeFilters['filter-5'] !== undefined) params.append('filter-5', this.activeFilters['filter-5'].join(','));
            if (this.activeFilters['search-query'] !== undefined) params.append('search-query', this.activeFilters['search-query']);
    
            xmlhttp.onreadystatechange = _ => {
                if (xmlhttp.readyState === XMLHttpRequest.DONE) {
                    if (xmlhttp.status === 200) {
                        const response = JSON.parse(xmlhttp.responseText);
    
                        this.deleteLocationsFromMap();
    
                        for (let i = 0; i < response.length; i++) {
                            const location = response[i];
                            const marker = new google.maps.Marker({
                                position: { lat: location.location[0], lng: location.location[1] },
                                map: this.map,
                                icon: this.mapIcon,
                                title: location.title
                            });
    
                            marker.se_location_data = location;
    
                            this.mapMarkers.push(marker);
    
                            marker.addListener('click', _ => {
                                this.showInfoBox(marker);
                                marker.setIcon(this.mapIconActive);
                            });
                        }
    
                        this.updateSubProjectList();
                    }
                    else {
                        alert('Oops, something went wrong..');
                    }
                }
            };
    
            xmlhttp.open('POST', se_ajax.ajaxurl, true);
            xmlhttp.send(params);
        },
    
        deleteLocationsFromMap() {
            this.closeInfoBox();
    
            for (let i = 0; i < this.mapMarkers.length; i++) {
                this.mapMarkers[i].setMap(null);
            }
    
            this.mapMarkers = [];
        },
    
        showInfoBox(marker) {
            this.closeInfoBox();
    
            const data = marker.se_location_data;
    
            let ibContent = '<div class="map-infobox__inner"><a href="' + data.url + '" class="map-infobox__link">' + data.title + '</a>';
                ibContent += '<div class="map-infobox__img">' +
                    '<a href="https://www.google.com/maps/place/' + data.gps_location + '" target="_blank">Navigeer naar dit project</a>' +
                    '<img src="' + data.thumbnail + '" alt="' + data.title + '" /></div>';
                ibContent += '<div class="map-infobox__content-wrapper">';
                    ibContent += '<div class="map-infobox__title">' + data.title + '</div>';
                    ibContent += '<a href="' + data.url + '" class="map-infobox__url">Bekijk project</a>';
                ibContent += '</div></div>';
    
            this.infobox = new InfoBox({
                content: ibContent,
                disableAutoPan: false,
                maxWidth: 0,
                zIndex: null,
                closeBoxMargin: '0px',
                closeBoxURL: '',
                infoBoxClearance: new google.maps.Size(1, 1),
                isHidden: false,
                pane: 'floatPane',
                enableEventPropagation: false
            });
    
            this.infobox.open(this.map, marker);
        },
    
        closeInfoBox() {
            if (this.infobox !== null) {
                this.infobox.close();
            }
    
            Array.prototype.forEach.call(this.mapMarkers, marker => {
                marker.setIcon(this.mapIcon);
            });
        },
    
        getVisibleMarkers() {
            return this.mapMarkers.filter(marker => {
                const bounds = this.map.getBounds();
    
                if (bounds) return this.map.getBounds().contains(marker.getPosition());
                return null;
            });
        },
    
        updateSubProjectList() {
            const visibleMarkers = this.getVisibleMarkers();
    
            if (! this.arraysEqual(visibleMarkers, this.prevVisibleMarkerList)) {
                this.prevVisibleMarkerList = visibleMarkers;
    
                const markers = visibleMarkers.slice(0, 3);
                const grid = this.container.querySelector('.jsSubProjectGrid');
        
                if (markers.length) {
                    const postIds = markers.map(marker => { return marker.se_location_data.id; });
        
                    // Do the request
                    const xmlhttp = new XMLHttpRequest();
                    const params = new FormData();
            
                    params.append('action', 'get_project_archive_grid_specific');
                    params.append('post_ids', postIds.join(','));
            
                    xmlhttp.onreadystatechange = _ => {
                        if (xmlhttp.readyState === XMLHttpRequest.DONE) {
                            if (xmlhttp.status === 200) {
                                const response = JSON.parse(xmlhttp.responseText);
            
                                new TimelineMax()
                                    .set(grid, { height: grid.offsetHeight })
                                    .to(grid, 0.5, { opacity: 0, ease: Power2.easeInOut })
                                    .add(_ => { grid.innerHTML = response.grid_html; })
                                    .to(grid, 0.5, { opacity: 1, ease: Power2.easeInOut })
                                    .set(grid, { clearProps: 'all' })
                                ;
                            }
                        }
                    };
            
                    xmlhttp.open('POST', se_ajax.ajaxurl, true);
                    xmlhttp.send(params);
                }
            }
        },
    
        arraysEqual(_arr1, _arr2) {
            if (!Array.isArray(_arr1) || ! Array.isArray(_arr2) || _arr1.length !== _arr2.length) return false;
        
            var arr1 = _arr1.concat().sort();
            var arr2 = _arr2.concat().sort();
        
            for (var i = 0; i < arr1.length; i++) {
                if (arr1[i] !== arr2[i]) return false;
            }
        
            return true;
        }
    });
    
    ArchiveView.init();
    
    const PageView = Barba.BaseView.extend({
        namespace: 'page',
    
        onEnter() {
            new MainMenu(this.container);
            new InViewAnimation();
            new SearchModal(this.container);
    
            setIframeAspectRatios(this.container);
        }
    });
    
    PageView.init();
    const VacancyArchiveView = Barba.BaseView.extend({
        namespace: 'vacancy-archive',
    
        onEnter: function() {
            new MainMenu(this.container);
            new InViewAnimation();
            new SearchModal(this.container);
       
            setIframeAspectRatios(this.container);
    
            setTimeout(_ => { setScrollAnchorPosition(this.container); }, 500)
            window.addEventListener('hashchange', _ => { setScrollAnchorPosition(this.container); });
        }
    });
    
    VacancyArchiveView.init();
    const SearchView = Barba.BaseView.extend({
        namespace: 'search',
    
        onEnter() {
            new MainMenu(this.container);
            new InViewAnimation();
            new SearchModal(this.container);
    
            setIframeAspectRatios(this.container);
    
            console.log('Hi search');
        }
    });
    
    SearchView.init();

    function SeMailchimpForm(container) {
        this.container = container;
        this.form = this.container.querySelector('.jsSignupNewsletterForm');
        this.emailInput = this.form.querySelector('.jsSignupNewsletterEmailInput');
        this.errorMsg = this.form.querySelector('.jsSignupFormErrorMsg');
        this.successMsg = this.form.querySelector('.jsSignupFormSuccessMsg');
        this.isSubmitting = false;
        
        this.form.addEventListener('submit', e => {
            e.preventDefault();
            this.submitForm();
        });
    }
    
    SeMailchimpForm.prototype.submitForm = function() {
        if (! this.isSubmitting) {
            if (! this.emailInput.value || this.emailInput.value === '') {
                this.showErrorMessage('Please enter your email address.');
                return false;
            }
            
            this.isSubmitting = true;
    
            // Submit the form
            const xmlhttp = new XMLHttpRequest();
            const params = new FormData();
    
            params.append('action', 'se_submit_mailchimp_signup');
            params.append('email', this.emailInput.value);
    
            xmlhttp.onreadystatechange = _ => {
                if (xmlhttp.readyState === XMLHttpRequest.DONE) {
                    this.isSubmitting = false;
    
                    if (xmlhttp.status === 200) {
                        const response = JSON.parse(xmlhttp.responseText);
    
                        if (response.success) this.showSuccessMessage();
                        else this.showErrorMessage(response.error);
                    }
                    else {
                        this.showErrorMessage('Oops.. Something went wrong. Please try again.');
                    }
                }
            };
    
            xmlhttp.open('POST', se_ajax.ajaxurl, true);
            xmlhttp.send(params);
        }
    };
    
    SeMailchimpForm.prototype.showErrorMessage = function(errorMessage) {
        this.errorMsg.innerHTML = errorMessage;
        this.successMsg.style.display = 'none';
        this.errorMsg.style.display = 'block';
    }
    
    SeMailchimpForm.prototype.showSuccessMessage = function() {
        this.emailInput.value = '';
        this.errorMsg.style.display = 'none';
        this.successMsg.style.display = 'block';
    }
    function initSlideshows(container) {
        const slideshows = container.querySelectorAll('.jsFullWidthSlideshow .slides');
    
        Array.prototype.forEach.call(slideshows, el => {
            imagesLoaded(el, function() {
                const slides = el.querySelectorAll('.slide');
                const slideCount = el.querySelectorAll('.slide').length;
                const slideCountEl = el.parentElement.querySelector('.jsSlideCount');
                const pinterestBtn = el.parentElement.querySelector('.pinterest-share-btn');
                const flickity = new Flickity(el, {
                    pageDots: false,
                    prevNextButtons: false,
                    wrapAround: true
                });
    
                // Set the slide counter
                slideCountEl.innerHTML = '01/' + addZero(slideCount);
    
                const btnPrev = el.parentElement.querySelector('.jsArrowPrev');
                const btnNext = el.parentElement.querySelector('.jsArrowNext');
    
                btnPrev.addEventListener('click', e => {
                    e.preventDefault();
                    flickity.previous(true);
                });
                
                btnNext.addEventListener('click', e => {
                    e.preventDefault();
                    flickity.next(true);
                });
    
                // Update the slide counter on slide
                flickity.on('change', index => {
                    slideCountEl.innerHTML = addZero(index + 1) + '/' + addZero(slideCount);
    
                    // Set the Pinterest button URL
                    const url = pinterestBtn.href;
                    pinterestBtn.href = url.substring(0, url.indexOf('&media=') + 7) + slides[index].dataset.pinterestImageUrl;
                });
            });
        });
    }
    function MainMenu(container) {
        this.container = container;
    
        this.topMenu = this.container.querySelector('.jsTopMenu');
        this.menuTrigger = this.container.querySelector('.jsMenuTrigger');
        this.mainMenu = this.container.querySelector('.jsMainMenu');
        this.mainMenuWrapper = this.mainMenu.querySelector('.jsMainMenuWrapper');
        this.mainMenuInner = this.mainMenu.querySelector('.jsMainMenuInner');
        this.mainMenuItems = this.mainMenu.querySelectorAll('li');
        this.mainMenuSubParents = this.mainMenu.querySelectorAll('li.menu-item-has-children');
        this.mainMenuSubItems = this.mainMenu.querySelectorAll('.menu > li > ul');
        this.mainMenuWasWhite = this.topMenu.classList.contains('top-menu--light');
        this.topContainer = this.container.querySelector('.jsTopContainer');
        this.topContainerHadShadow = this.topContainer.classList.contains('shadow');
    
        this.topLogo = this.container.querySelector('.jsTopLogo');
    
        this.menuTrigger.addEventListener('click', e => {
            e.preventDefault();
    
            if (!this.mainMenu.classList.contains('open')) this.show();
            else this.hide();
        });
    
        this.initSubItems();
    
        // Hide the menu when the screen becomes too wide
        window.addEventListener('resize', () => {
            if (window.innerWidth >= 1100) this.hide();
        });
    
        // Fix the submenu on tablets
        if (document.documentElement.classList.contains('mobile')) {
            this.initMobileClick();
        }
    
        // Hide the menu on clicking a link
        const anchorLinks = this.mainMenu.querySelectorAll('a');
        Array.prototype.forEach.call(anchorLinks, el => {
            el.addEventListener('click', e => {
                if (!el.classList.contains('touch-show-submenu')) {
                    if (el.getAttribute('href') === '#') {
                        e.preventDefault();
                        return;
                    }
    
                    this.hide();
                }
            });
        });
    
        Array.prototype.forEach.call(this.mainMenuItems, item => {
            if (item.classList.contains('menu-item-has-children')) {
                const submenu = item.querySelector('.sub-menu');
                const menuItems = submenu.querySelectorAll('li');
    
                item.addEventListener('mouseenter', e => {
                    if (window.innerWidth >= 850) {
                        new TimelineMax()
                            .set(menuItems, { y: 15 })
                            .to(submenu, 0.5, { opacity: 1, ease: Power2.easeInOut })
                            .staggerTo(menuItems, 1, { y: 0, ease: Power2.easeOut }, '0.1', '-=0.5')
                        ;
                    }
                });
        
                item.addEventListener('mouseleave', () => {
                    if (window.innerWidth >= 850) {
                        TweenLite.to(submenu, 0.5, { opacity: 0, ease: Power2.easeInOut, onComplete: () => {
                            TweenLite.set(submenu, { clearProps: 'all' });
                        } });
                    }
                });
            }
        });
    }
    
    MainMenu.prototype.initSubItems = function() {
        // Don't do this on mobile devices
        if (document.documentElement.classList.contains('mobile')) return;
    
        const expertisesItemEl = this.topMenu.querySelector('.jsExpertisesMenuItem');
        const expertiseMenuEl = this.topMenu.querySelector('.jsExpertiseSubmenu');
        const colEls = expertiseMenuEl.querySelectorAll('.jsCol');
    
        expertisesItemEl.addEventListener('mouseenter', () => {
            gsap.timeline()
                .set(expertiseMenuEl, { y: 10, display: 'block', opacity: 0 })
                .set(colEls, { y: 10, opacity: 0 })
    
                .to(expertiseMenuEl, { duration: 0.5, y: 0, opacity: 1, ease: 'Power2.out' })
                .to(colEls, { duration: 0.5, y: 0, opacity: 1, ease: 'Power2.out', stagger: 0.05 }, '-=0.4')
    
                .set([expertiseMenuEl, ...colEls], { clearProps: 'all' })
            ;
        });
    
        expertisesItemEl.addEventListener('mouseleave', () => {
            gsap.timeline()
                .set(expertiseMenuEl, { display: 'block' })
    
                .to(expertiseMenuEl, { duration: 0.5, y: 10, opacity: 0, ease: 'Power2.in' })
                .to(colEls, { duration: 0.5, y: 10, opacity: 0, ease: 'Power2.in', stagger: 0.05 }, '-=0.5')
    
                .set([expertiseMenuEl, ...colEls], { clearProps: 'all' })
            ;
        });
    
        // Do the same as above for the regular menu items
        const menuItemEls = this.topMenu.querySelectorAll('.menu-item-has-children');
        menuItemEls.forEach(el => {
            el.addEventListener('mouseenter', e => {
                const subMenuEl = e.target.querySelector('ul');
                const menuItemEls = subMenuEl.querySelectorAll('li');
    
                gsap.timeline()
                    .set(subMenuEl, { y: 10, display: 'block', opacity: 0 })
                    .set(menuItemEls, { y: 10, opacity: 0 })
    
                    .to(subMenuEl, { duration: 0.5, y: 0, opacity: 1, ease: 'Power2.out' })
                    .to(menuItemEls, { duration: 0.5, y: 0, opacity: 1, ease: 'Power2.out', stagger: 0.05 }, '-=0.5')
    
                    .set([subMenuEl, ...menuItemEls], { clearProps: 'all' })
                ;
            });
    
            el.addEventListener('mouseleave', e => {
                const subMenuEl = e.target.querySelector('ul');
                const menuItemEls = subMenuEl.querySelectorAll('li');
    
                gsap.timeline()
                    .set(subMenuEl, { display: 'block' })
    
                    .to(subMenuEl, { duration: 0.5, y: 10, opacity: 0, ease: 'Power2.in' })
                    .to(menuItemEls, { duration: 0.5, y: 10, opacity: 0, ease: 'Power2.in' }, '-=0.5')
    
                    .set([subMenuEl, ...menuItemEls], { clearProps: 'all' })
                ;
            });
        });
    };
    
    MainMenu.prototype.show = function() {
        // Scroll the window to the top and disable scrolling
        document.body.classList.add('no-scroll');
        this.topContainer.classList.remove('shadow');
        vanillaSmoothie.scrollTo(0, { duration: 500, easing: 'easeInOutQuad' });
    
        // Show the main menu
        this.menuTrigger.classList.add('active');
    
        new TimelineMax()
            .set(this.mainMenuWrapper, { yPercent: -100 })
            .set(this.mainMenuInner, { yPercent: 110 })
    
            .set(this.mainMenuItems, { y: 15, opacity: 0 })
            .add(() => this.mainMenu.classList.add('open'))
            .add(() => this.mainMenuInner.scrollTo(0, 0))
    
            .to([this.mainMenuWrapper, this.mainMenuInner], 0.8, { yPercent: 0, ease: Power2.easeInOut })
            .staggerTo(this.mainMenuItems, 0.8, { y: 0, opacity: 1, ease: Power2.easeOut }, 0.1, 0.6)
        ;
    
        // Set the correct color classes
        this.topMenu.classList.remove('top-menu--red');
        this.topMenu.classList.remove('top-menu--orange');
        this.topMenu.classList.remove('top-menu--green');
        this.topMenu.classList.remove('top-menu--blue');
        this.topMenu.classList.remove('top-menu--light');
    
        this.topLogo.classList.remove('top-logo--orange');
        this.topLogo.classList.remove('top-logo--green');
        this.topLogo.classList.remove('top-logo--blue');
        this.topLogo.classList.add('top-logo--red');
    };
    
    MainMenu.prototype.hide = function() {
        if (this.topContainerHadShadow) this.topContainer.classList.add('shadow');
    
        // Hide the main menu
        new TimelineMax()
            .to(this.mainMenuWrapper, 0.8, { yPercent: -100, ease: Power2.easeInOut })
            .to(this.mainMenuInner, 0.8, { yPercent: 110, ease: Power2.easeInOut }, '-=0.8')
            .add(() => {
                // Set the correct color classes
                this.topMenu.classList.remove('top-menu--red');
                if (this.mainMenuWasWhite) this.topMenu.classList.add('top-menu--light');
                else this.topMenu.classList.add('top-menu--' + this.topMenu.dataset.topMenuOrigColor);
    
                this.topLogo.classList.remove('top-logo--red');
                this.topLogo.classList.remove('top-logo--light');
                this.topLogo.classList.add('top-logo--' + this.topLogo.dataset.topLogoOrigColor);
    
                this.menuTrigger.classList.remove('active');
            }, '-=0.5')
            .add(() => {
                this.mainMenu.classList.remove('open');
                
                // Enable scrolling
                document.body.classList.remove('no-scroll');
            })
        ;
    };
    
    MainMenu.prototype.initMobileClick = function() {
        if (document.documentElement.classList.contains('mobile') && window.innerWidth >= 850) {
            Array.prototype.forEach.call(this.mainMenuSubParents, item => {
                if (item.classList.contains('menu-item-has-children') && window.innerWidth >= 850) {
                    const anchor = item.querySelector('a');
    
                    anchor.addEventListener('click', e => {
                        if (! anchor.classList.contains('touch-show-submenu')) {
                            e.preventDefault();
                            e.stopPropagation();
        
                            Array.prototype.forEach.call(this.mainMenuItems, i2 => i2.querySelector('a').classList.remove('touch-show-submenu'));
                            anchor.classList.add('touch-show-submenu');
                        }
                        else {
                            Array.prototype.forEach.call(this.mainMenuItems, i2 => i2.querySelector('a').classList.remove('touch-show-submenu'));
                        }
                    });
                }
            });
        }
    };
    // const mousePointer = document.querySelector('.jsMousePointer');
    
    // if (mousePointer !== null) {
    //     window.addEventListener('mousemove', e => {
    //         TweenLite.set(mousePointer, { x: e.pageX - (mousePointer.offsetWidth / 2), y: e.pageY - (mousePointer.offsetHeight / 2) });
    //     });
    // }
    (function() {
    
        let lastClickedEl = null;
    
        Barba.Dispatcher.on('linkClicked', el => {
            lastClickedEl = el;
        });
    
        if (document.readyState === 'complete') initBarba();
        else document.onreadystatechange = _ => {
            if (document.readyState === 'complete') initBarba();
        }
    
        function initBarba() {
            Barba.Pjax.Dom.wrapperId = 'site-wrapper';
            Barba.Pjax.Dom.containerClass = 'site-wrapper__container';
            Barba.Prefetch.init();
            Barba.Pjax.start();
        }
    
        // Fade transition
        const FadeTransition = Barba.BaseTransition.extend({
            start: function() {
                let fadeOutComplete = false;
                let newContainerLoaded = false;
    
                vanillaSmoothie.scrollTo(0, { duration: 500, easing: 'easeInOutQuad' });
    
                TweenMax.to(this.oldContainer, 1, { opacity: 0, ease: Power4.easeInOut, onComplete: _ => {
                    fadeOutComplete = true;
    
                    document.body.scrollTop = 0;
                    document.documentElement.scrollTop = 0;
    
                    if (newContainerLoaded) this.finish();
                } });
    
                this.newContainerLoading.then(_ => {
                    TweenMax.set(this.newContainer, { position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, opacity: 0 });
                    newContainerLoaded = true;
                    if (fadeOutComplete) this.finish();
                });
            },
            finish: function() {
                document.body.scrollTop = 0;
    
                TweenMax.set(this.newContainer, { position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, opacity: 0 });
                TweenMax.to(this.newContainer, 1, { opacity: 1, ease: Power4.easeInOut, onComplete: _ => { TweenMax.set(this.newContainer, { clearProps: 'all' }) } });
    
                this.done();
            }
        });
    
        // Direct transition
        const DirectTransition = Barba.BaseTransition.extend({
            start: function() {
                setTimeout(_ => {
                    this.newContainerLoading.then(_ => this.finish());
                }, 1100);
            },
            finish: function() {
                this.done();
            }
        });
    
        // Topic home transition
        const TopicHomeTransition = Barba.BaseTransition.extend({
            start: function() {
                const slogan = this.oldContainer.querySelector('.jsHeaderSlogan');
                const scrollForMore = this.oldContainer.querySelector('.jsFirstScrollForMore');
    
                vanillaSmoothie.scrollTo(0, { duration: 500, easing: 'easeInOutQuad' });
        
                this.newContainerLoading.then(_ => {
                    new TimelineMax({ onComplete: _ => {
                        TweenLite.set(this.newContainer, { clearProps: 'all' });
                        this.done();
                    } })
                        // .staggerTo(topicSwitcherElements, 0.2, { x: -10, opacity: 0 }, 0.1)
                        .to(slogan, 0.2, { x: -10, opacity: 0 })
                        .to(scrollForMore, 0.2, { opacity: 0, y: 10 })
                        .set(this.newContainer, { position: 'absolute', visibility: 'visible', top: 0, right: 0, bottom: 0, left: 0, zIndex: 2, opacity: 0 })
                        .to(this.oldContainer, 1, { opacity: 0, ease: Power2.easeInOut })
                        .to(this.newContainer, 1, { opacity: 1, ease: Power2.easeInOut }, '-=1')
                    ;
                });
            }
        });
    
        Barba.Pjax.getTransition = function() {
            const prevUrl = Barba.HistoryManager.prevStatus().url;
            const nextUrl = Barba.HistoryManager.currentStatus().url;
    
            if (topicHomePages.indexOf(prevUrl) > -1 && topicHomePages.indexOf(nextUrl) > -1) {
                return TopicHomeTransition;
            }
    
            return FadeTransition;
        };
    
    })();
    function initProjectBoxes(container) {
        const projectBoxes = container.querySelectorAll('.project-box');
    
        Array.prototype.forEach.call(projectBoxes, box => {
            const projectBoxImages = box.querySelectorAll('.project-box__images div');
            const projectBoxProjects = box.querySelectorAll('.project-box__list .project-box__project a');
        
            if (!document.documentElement.classList.contains('mobile')) {
                Array.prototype.forEach.call(projectBoxProjects, (project, index) => {
                    project.addEventListener('mouseover', _ => activateBoxWithIndex(projectBoxProjects, projectBoxImages, index));
                });
    
                window.addEventListener('resize', _ => {
                    if (window.innerWidth >= 800) activateBoxWithIndex(projectBoxProjects, projectBoxImages, 0);
                });
            }
            else {
                let index = 0;
                let projectCount = projectBoxProjects.length;
    
                setInterval(_ => {
                    index++;
                    if (index > (projectCount - 1)) index = 0;
    
                    activateBoxWithIndex(projectBoxProjects, projectBoxImages, index);
                }, 3000);
            }
        });
    
    
        function activateBoxWithIndex(projectBoxProjects, projectBoxImages, index) {
            for (let i = 0; i < projectBoxProjects.length; i++) {
                if (window.innerWidth >= 800 && i === index) {
                    projectBoxImages[i].classList.add('active');
                    projectBoxProjects[i].parentElement.classList.add('active');
                }
                else {
                    projectBoxImages[i].classList.remove('active');
                    projectBoxProjects[i].parentElement.classList.remove('active');
                }
            }
        }
    }
    function initScrollForMoreTriggers(container) {
        const triggers = container.querySelectorAll('.scroll-for-more');
    
        Array.prototype.forEach.call(triggers, el => {
            el.addEventListener('click', e => {
                e.preventDefault();
    
                const scrollToEl = document.getElementById(el.dataset.scrollTo);
    
                if (scrollToEl !== null) {
                    const bounds = scrollToEl.getBoundingClientRect();
                    vanillaSmoothie.scrollTo(bounds.top + window.scrollY, { duration: 500, easing: 'easeInOutQuad' });
                }
            });
        });
    }
    (function() {
        const toTopBtn = document.querySelector('.jsToTopBtn');
    
        toTopBtn.addEventListener('click', e => {
            e.preventDefault();
            vanillaSmoothie.scrollTo(0, { duration: 500, easing: 'easeInOutQuad' });
        });
    
        window.addEventListener('scroll', _ => {
            if (window.scrollY > (window.innerHeight / 4)) {
                toTopBtn.classList.add('visible');
            }
            else {
                toTopBtn.classList.remove('visible');
            }
        });
    })();
    function setIframeAspectRatios(container) {
        const arIframes = container.querySelectorAll('iframe');
    
        Array.prototype.forEach.call(arIframes, el => {
            setIframeAspectRatio(el);
            window.addEventListener('resize', _ => setIframeAspectRatio(el));
        });
    }
    
    function getIframeAspectRatio(iframeElement) {
        let aspectRatio = iframeElement.dataset.aspectRatio;
    
        if (aspectRatio) {
            aspectRatio = aspectRatio.split(':');
        }
        else {
            const definedWidth = iframeElement.getAttribute('width');
            const definedHeight = iframeElement.getAttribute('height');
    
            aspectRatio = [1, (definedHeight / definedWidth)];
        }
    
        return aspectRatio;
    }
    
    function setIframeAspectRatio(iFrameElement) {
        const ratio = getIframeAspectRatio(iFrameElement);
        iFrameElement.style.height = Math.min(((iFrameElement.offsetWidth / ratio[0]) * ratio[1]), window.innerHeight) + 'px';
    }
    function ArchiveFilter(filter) {
        const title = filter.querySelector('.jsArchiveFilterTitle');
        const expandWrapper = filter.querySelector('.jsArchiveFilterExpandWrapper');
    
        title.addEventListener('click', () => {
            if (!expandWrapper.classList.contains('open')) {
                title.classList.add('active');
    
                TweenLite.set(expandWrapper, { display: 'block', opacity: 0 });
                const height = expandWrapper.offsetHeight;
                TweenLite.set(expandWrapper, { height: 0, opacity: 1 });
                TweenLite.to(expandWrapper, 0.5, { height: height, ease: Power2.easeInOut, onComplete: () => {
                    expandWrapper.classList.add('open');
                    TweenLite.set(expandWrapper, { clearProps: 'all' });
                } });
            }
            else {
                title.classList.remove('active');
    
                TweenLite.to(expandWrapper, 0.5, { height: 0, ease: Power2.easeInOut, onComplete: () => {
                    expandWrapper.classList.remove('open');
                    expandWrapper.classList.remove('open-children');
    
                    TweenLite.set(expandWrapper, { clearProps: 'all' });
                } });
            }     
        });
    }
    function setScrollAnchorPosition(container) {
        if (window.location.hash) {
            const el = container.querySelector('[data-id="' + window.location.hash.replace('#', '') + '"]');
    
            if (el !== null) {
                const bounds = el.getBoundingClientRect();
                vanillaSmoothie.scrollTo(bounds.top + window.scrollY, { duration: 500, easing: 'easeInOutQuad' });
            }
        }
    }
    function InViewAnimation() {
        this.scrollDirectionUp = false;
        this.scrollPos = 0;
    
        // Set the scroll direction
        window.addEventListener('scroll', e => {
            this.scrollDirectionUp = this.scrollPos > window.scrollY;
            this.scrollPos = window.scrollY;
        });
    
        inView.offset(0);
    
        // Animate elements in when entering the view
        inView('.in-view-up')
            .on('enter', el => el.classList.add('done'))
            .on('exit', el => {
                inView.offset(0);
                if (this.scrollDirectionUp) el.classList.remove('done');
            })
        ;
    };
    function ReadMoreTrigger(container) {
        this.container = container;
    
        const trigger = this.container.querySelector('.jsReadMoreTrigger');
        const wrapper = this.container.querySelector('.jsReadMoreWrapper');
    
        if (trigger) {
            trigger.addEventListener('click', _ => {
                trigger.classList.toggle('open');
                wrapper.classList.toggle('open');
            });
        
            window.addEventListener('resize', _ => {
                if (window.innerWidth >= 850) {
                    trigger.classList.remove('open');
                    wrapper.classList.remove('open');
                }
            });
        }
    }
    function HomeHeaderSlideshow(el) {
        this.el = el;
        this.progressEl = this.el.querySelector('.jsHomeHeaderProgress');
        this.slideWrapperEl = this.el.querySelector('.jsHomeHeaderSlides');
        this.slideEls = this.slideWrapperEl.querySelectorAll('.jsHomeHeaderSlides .jsSlide');
        this.currentSlideIndex = 0;
        this.slideTimeout = 7000;
    
        // Project intro
        this.projectIntroEl = this.el.querySelector('.jsProjectIntro');
        this.projectIntroTitleEl = this.projectIntroEl.querySelector('.jsProjectTitle');
        this.projectIntroLinkEl = this.projectIntroEl.querySelector('.jsProjectLink');
    
        // Set the current slide video aspect ratio
        const currentSlideVideoEl = this.slideEls[0].querySelector('video');
        if (currentSlideVideoEl) this.setVideoAspectRatio(currentSlideVideoEl);
    
        // Add resize listeners for the current slide video
        window.addEventListener('resize', () => {
            const currentSlideVideoEl = this.slideEls[this.currentSlideIndex].querySelector('video');
            if (currentSlideVideoEl) this.setVideoAspectRatio(currentSlideVideoEl);
        });
        
        // Start the autoslide interval
        this.restartProgressBar();
        setInterval(() => this.nextSlide(), this.slideTimeout);
    }
    
    HomeHeaderSlideshow.prototype.restartProgressBar = function() {
        gsap.timeline()
            .set(this.progressEl, { width: 0, opacity: 1 })
            .to(this.progressEl, { duration: (this.slideTimeout / 1000) - 0.4, width: '100%', ease: Power2.easeInOut })
            .to(this.progressEl, { duration: 0.3, opacity: 0, ease: Power2.easeInOut })
        ;
    };
    
    HomeHeaderSlideshow.prototype.nextSlide = function() {
        const currentSlideEl = this.slideEls[this.currentSlideIndex];
        const nextSlideIndex = (this.currentSlideIndex + 1) > (this.slideEls.length - 1) ? 0 : this.currentSlideIndex + 1;
        const nextSlideEl = this.slideEls[nextSlideIndex];
    
        this.restartProgressBar();
    
        if (!nextSlideEl) return;
    
        const nextSlideVideoEl = nextSlideEl.querySelector('video');
    
        gsap.timeline()
            .set(nextSlideEl, { opacity: 0, display: 'block' })
            .add(() => {
                nextSlideEl.classList.add('next');
                this.setVideoAspectRatio(nextSlideVideoEl);
            })
    
            .to(this.projectIntroTitleEl, { duration: 0.5, y: -5, opacity: 0, ease: 'power2.inOut' })
            .to(nextSlideEl, { duration: 0.5, opacity: 1, ease: 'power2.inOut' }, '-=0.5')
    
            .set(this.projectIntroTitleEl, { y: 5 })
    
            .add(() => {
                this.projectIntroTitleEl.innerHTML = nextSlideEl.dataset.projectTitle;
                this.projectIntroLinkEl.href = nextSlideEl.dataset.projectUrl;
            })
    
            .to(this.projectIntroTitleEl, { duration: 0.5, y: 0, opacity: 1, ease: 'power2.inOut' })
    
            .add(() => {
                currentSlideEl.classList.remove('visible');
                nextSlideEl.classList.add('visible');
                nextSlideEl.classList.remove('next');
            })
            .set([currentSlideEl, nextSlideEl], { clearProps: 'display,opacity' })
        ;
     
        this.currentSlideIndex = nextSlideIndex;
    };
    
    HomeHeaderSlideshow.prototype.setVideoAspectRatio = function(videoEl) {
        if (videoEl !== null) {
            this.setVideoWidthHeight(videoEl);
            window.addEventListener('resize', () => this.setVideoWidthHeight(videoEl));
    
            if (document.readyState === 'complete') gsap.to(videoEl, 0.5, { opacity: 1, ease: 'power2.inOut' })
            else window.addEventListener('load', () => gsap.to(videoEl, 0.5, { opacity: 1, ease: 'power2.inOut' }));
        }
    };
    
    HomeHeaderSlideshow.prototype.getVideoWidthHeight = function() {
        const aspectRatio = 16 / 9;
    
        const windowWidth = window.innerWidth;
        const windowHeight = this.el.offsetHeight;
    
        let videoWidth = windowWidth;
        let videoHeight = windowWidth / aspectRatio;
    
        if (windowHeight > videoHeight) {
            videoHeight = windowHeight;
            videoWidth = videoHeight * aspectRatio;
        }
    
        return [videoWidth, videoHeight];
    };
    
    HomeHeaderSlideshow.prototype.setVideoWidthHeight = function(videoEl) {
        const videoWidthHeight = this.getVideoWidthHeight();
    
        videoEl.style.width = videoWidthHeight[0] + 'px';
        videoEl.style.height = videoWidthHeight[1] + 'px';
    };
    function SearchModal(container) {
        this.el = container.querySelector('.jsSearchModal');
        this.closeBtnEl = this.el.querySelector('.jsSearchModalCloseBtn');
        this.formEl = this.el.querySelector('.jsSearchModalForm');
    
        // Event listeners
        document.body.addEventListener('click', e => {
            if (e.target.classList.contains('jsSearchModalTrigger')) {
                e.preventDefault();
                this.show();
            }
        });
        
        this.el.addEventListener('click', e => {
            if (e.target.classList.contains('jsCloseModal')) {
                e.preventDefault();
                this.hide();
            }
        });
    
        window.addEventListener('keyup', e => {
            if (e.key.toLowerCase() === 'escape') this.hide();
        });
    }
    
    SearchModal.prototype.show = function() {
        // Scroll to top
        vanillaSmoothie.scrollTo(0, { duration: 500, easing: 'easeInOutQuad' });
    
        // Animate
        gsap.timeline()
            .set(this.el, { opacity: 0 })
            .set(this.formEl, { y: -15, opacity: 0 })
            .add(_ => {
                this.el.classList.add('visible');
                this.formEl.querySelector('input').focus();
            })
    
            .to(this.el, { duration: 0.3, opacity: 1, ease: Power2.inOut })
            .to(this.formEl, { duration: 0.3, y: 0, opacity: 1, ease: Power2.inOut }, '-=0.3')
            
            .set([this.el, this.formEl], { clearProps: 'all' })
        ;
    };
    
    SearchModal.prototype.hide = function() {
        gsap.timeline()
            .to(this.el, { duration: 0.3, opacity: 0, ease: Power2.inOut })
            .to(this.formEl, { duration: 0.3, y: -15, opacity: 0, ease: Power2.inOut }, '-=0.3')
            
            .add(_ => this.el.classList.remove('visible'))
            .set([this.el, this.formEl], { clearProps: 'all' })
        ;
    };
    function NewsGridSlider(el) {
        this.el = el;
        this.gridEl = this.el.querySelector('.jsGrid');
        this.btnWrapper = this.el.querySelector('.jsBtnWrapper');
    
        this.init();
        this.setBtnVisibility();
    }
    
    NewsGridSlider.prototype.init = function () {
        window.addEventListener('resize', () => this.setBtnVisibility());
    
        this.flickity = new Flickity(this.gridEl, {
            pageDots: false,
            prevNextButtons: false,
            cellAlign: 'left',
            contain: true,
            groupCells: true,
            on: {
                change: () => this.setBtnVisibility()
            }
        });
    
        this.el.addEventListener('click', e => {
            if (e.target.classList.contains('prev')) this.flickity.previous();
            else if (e.target.classList.contains('next')) this.flickity.next();
        });
    
        // Prevent clicking links while dragging the slider
        this.flickity.on('dragStart', () => this.flickity.slider.style.pointerEvents = 'none');
        this.flickity.on('dragEnd', () => this.flickity.slider.style.pointerEvents = 'auto');
    }
    
    NewsGridSlider.prototype.setBtnVisibility = function() {
        // Show or hide all buttons
        let show = true;
    
        if (window.innerWidth < 650) show = this.flickity.cells.length > 1;
        else if (window.innerWidth < 1000) show = this.flickity.cells.length > 2;
        else show = this.flickity.cells.length > 3;
    
        this.btnWrapper.style.display = !show ? 'none' : '';
    
        // Show or hide individual buttons
        const current = this.flickity.selectedIndex;
        const total = this.flickity.slides.length;
    
        this.el.querySelector('.prev').disabled = current === 0;
        this.el.querySelector('.next').disabled = current >= total - 1;
    };

    function addZero(number) {
        if (number < 10) return '0' + number;
        return '' + number;
    }

})();